import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Our_Casino_Game from "../../../assets/Services/Casino_Game_Dev/Our_Casino_Game.png";

import AIDriven_Game from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/AI-Driven_Game.svg";
import Blockchain_ from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Blockchain_&_Cryptocurrency.svg";
import Custom_Casino_Game from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Custom_Casino_Game.svg";
import Launch_Support from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Launch_Support.svg";
import Live_Dealer_ from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Live_Dealer_&_Real-Time.svg";
import Providing from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Providing-license.svg";
import Secure_Payment from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Secure_Payment.svg";
import Social_Features from "../../../assets/Services/Casino_Game_Dev/Our_End-to-End_AR/Social_Features.svg";

import Casino_elite from "../../../assets/Services/Casino_Game_Dev/The_Facilities_We_Provide/Casino_elite.png";
import Live_dealer_int from "../../../assets/Services/Casino_Game_Dev/The_Facilities_We_Provide/Live_dealer_int.png";
import Multi_game_type from "../../../assets/Services/Casino_Game_Dev/The_Facilities_We_Provide/Multi_game_type.png";

import Maskgroup from "../../../assets/Services/Casino_Game_Dev/Voice_of_Success/Maskgroup-1.png";
import Maskgroup2 from "../../../assets/Services/Casino_Game_Dev/Voice_of_Success/Maskgroup-2.png";
import Maskgroup3 from "../../../assets/Services/Casino_Game_Dev/Voice_of_Success/Maskgroup.png";

import Deployment_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Deployment_&_Maintenance.svg";
import Design_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Design_&_Prototyping.svg";
import GameDevelopment from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Game Development.svg";
import Requirement_Analysis from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Requirement_Analysis.svg";
import Testing_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Testing_&_Quality.svg";

import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";
import Poker_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png";

import AI from "../../../assets/Services/Casino_Game_Dev/Casino_icons/AI-Driven_Player.svg";
import Advanced_Multiplayer from "../../../assets/Services/Casino_Game_Dev/Casino_icons/Advanced_Multiplayer.svg";
import Comprehensive_Security from "../../../assets/Services/Casino_Game_Dev/Casino_icons/Comprehensive_Security.svg";
import Global_Market from "../../../assets/Services/Casino_Game_Dev/Casino_icons/Global_Market.svg";
import Rearmost_Technology from "../../../assets/Services/Casino_Game_Dev/Casino_icons/Rearmost_Technology.svg";
import Scalable_Gaming from "../../../assets/Services/Casino_Game_Dev/Casino_icons/Scalable_Gaming.svg";

import icon from "../../../assets/Services/Game_page/casino/icon.png";
import icon2 from "../../../assets/Services/Game_page/casino/icon2.png";
import icon3 from "../../../assets/Services/Game_page/casino/main.png";
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";

const CasinoGameDev = () => {
   const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Casino Elite ",
      desc: "Casino Elite is an end-to-end casino gaming platform constructed with enterprise-level security, breathtaking graphics, and frictionless gameplay providing an immersive, fair, and scalable casino experience.",
      img: Casino_elite,
    },
    {
      title: "Multiple Game Types ",
      desc: " There are multiple types of modes for different types of games, such as slot games and table games. The mode has different rules and time limits that are for various player skill levels. This variety keeps players interested. ",
      img: Multi_game_type,
    },
    {
      title: "Live Dealer Integration ",
      desc: "We create live casino experiences with expert dealers broadcasting from advanced studios. HD video streaming with multiple camera positions and and  chat options for a live casino environment.",
      img: Live_dealer_int,
    },
    {
      title: "Advanced RNG Systems ",
      desc: " Certified Random Number Generation allows fair play for all the games. Third-party audited algorithms provide random outcomes and maintain player confidence through transparent gameplay mechanics.",
      img: " ",
    },
    {
      title: "VIP & Loyalty Programs ",
      desc: " Multi-level reward systems reward systems with reserved bonuses, cashback, and free account handling. Progressive loyalty point system with live rewards and VIP access",
      img: "",
    },
    {
      title: "Multi-Platform Availability",
      desc: " Smooth gaming on desktop, mobile, and tablet platforms with linked accounts and game state. Native iOS and Android applications with web-based versions for multi-platform availability.",
      img: "",
    },
  ];

  const pokerdevcompany = [
    {
      title: " Requirement Analysis & Planning",
      icon: Requirement_Analysis,
      desc: "We start by determining client requirements, collecting needs, and outlining project scope. Our professionals make sure a tailored ludo game that supports your brand image, audience desires, and incorporates features such as RNG and multiplayer support.",
    },
    {
      title: " Design & Prototyping",
      icon: Design_,
      desc: "Our designers make wireframes and interactive prototypes based on a user friendly interface. We provide responsive designs that can be used in multiple devices, from mobile to web, with a consistent experience that includes optimized ludo game mechanics and intuitive visuals.",
    },
    {
      title: " Development & Integration",
      icon: GameDevelopment,
      desc: "Our team of developers utilizes state-of-the-art technologies to give your Ludo game an end-to-end solution. We create features like advanced real-time multiplayer support, chat, a secure payment gateway, and high-quality graphics that provide a better gaming experience to users.",
    },
    {
      title: " Deployment & Maintenance",
      icon: Deployment_,
      desc: "After successful testing, we deploy the Ludo game across platforms and provide maintenance support. Our support team gives timely updates, bug fixes, and feature enhancements to keep the game fresh, relevant, and engaging for players over time.",
    },
    {
      title: " Testing & Quality Assurance",
      icon: Testing_,
      desc: "Stringent testing and QA processes are used to provide bug-free performance. We perform functional, usability, and security testing for uninterrupted gameplay, authentic dice rolling mechanics, and a secure online environment. All tests ensure the integrity and fairness of the Ludo game.",
    },
  ];

  const pokerdevcompany2 = [
    {
      title: "  Latest Technology Integration ",
      icon: Rearmost_Technology,
      desc: " We use  AI, blockchain, cryptocurrency-based integration, and performance graphics engines to develop advanced casino games. Our developers use Unity 3D, Unreal Engine, React Native, Node.js, smart contracts, and enterprise cloud infrastructure ",
    },

    {
      title: " Comprehensive Security & Regulatory Compliance  ",
      icon: Comprehensive_Security,
      desc: "Raiden Labs uses financial security measures, certified random number generator systems, and have anti-fraud options to provide safe gaming. Our security measures include SSL encryption, PCI DSS Level 1 certification, multi-factor authentication, live transaction tracking, and full audit report   ",
    },

    {
      title: "  Global Regulatory Expertise ",
      icon: Global_Market,
      desc: "Our team has vast experience with gaming regulation in USA, Europe, Asia, and the emerging markets. We verify that your casino platform meets domestic gambling laws, licensing laws, tax policies, and responsible gaming requirements for seamless international rollouts.  ",
    },

    {
      title: "Scalable Gaming Infrastructure   ",
      icon: Scalable_Gaming,
      desc: "We specialize in developing high-performance casino platforms that support millions of simultaneous players with no downtime. Our enterprise-level architecture delivers fast game loads, live multiplayer capability, instant payment settlement, and multiple platform synchronization without any lag. ",
    },

    {
      title: "AI-Driven Player Intelligence   ",
      icon: AI,
      desc: "Our AI solutions maximize player engagement by making tailored game suggestions, dynamic bonus promotions, behavioral analysis, and responsible gambling monitoring. Machine learning algorithms continuously balance player lifetime value with ethical gaming standards.  ",
    },
  ];

  const gamedevservices = [
    {
      title: "Arcade Game Development",
      icon: Arcade_Game_Development,
      desc: " Design adrenaline-charged arcade experiences with fast-paced gameplay, eye-catching visuals, and high replayability—optimized for both mobile and web platforms.",
      link: "/arcade-game-development",
    },
    {
      title: "Poker  Game Development  ",
      icon: Poker_Game_Development,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon: Rummy_Game_Development,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon: Custom_Casino_Game,
      title: "Custom Casino Game Development ",
      desc: "Our skilled designers develop interactive and intuitive casino game user interfaces with themes, betting, and visual effects that can be tailored. We prioritize user experience optimization to provide seamless navigation, instant control, and engaging gameplay across devices and game types.",
    },
    {
      icon: Live_Dealer_,
      title: "Live Dealer & Real-Time Gaming  ",
      desc: "Create advanced casino platforms hosting live dealer games using live streaming technology. Our solutions allow many players to play together in poker tables, roulette wheels, and blackjack games with professional dealers and HD video streams.",
    },
    {
      icon: Secure_Payment,
      title: "Secure Payment & Crypto Integration",
      desc: "Establish secure payment systems that support conventional banking channels and cryptocurrency transactions. Our PCI DSS Level 1 approved solutions provide safe deposits and withdrawals with multi-layered fraud protection and instant transaction processing.",
    },
    {
      icon: AIDriven_Game,
      title: "AI-Driven Game Analytics  ",
      desc: "Utilize machine learning models to examine player conduct, optimize game performance, and enact responsible gambling controls. Our AI solutions offer personalized game suggestions, identify problem gambling behavior, and increase player loyalty through data-driven reasoning.",
    },
    {
      icon: Providing,
      title: "Providing license   ",
      desc: "Creating detailed gaming regulations in different jurisdictions, such as Malta, UK, Curacao, and Gibraltar. Our specialists make sure your casino site has all legal requirements, KYC/AML checks, and gaming procedures.",
    },
    {
      icon: Blockchain_,
      title: "Blockchain & Cryptocurrency Support ",
      desc: "Integrating blockchain in gaming helps to secure transactions and support for cryptocurrencies. Implementation of smart contracts allows automatic payouts, clear game outcomes, and decentralized gaming processes to increase player confidence.",
    },
    {
      icon: Social_Features,
      title: "Social Features & Tournament Systems ",
      desc: " We create engaging social gaming features, such as friend systems, live chat, leaderboards, and multiplayer tournaments. where players can join social groups and participate in every event that they post in their groups ",
    },
    {
      icon: Launch_Support,
      title: "Launch Support & Ongoing Maintenance ",
      desc: " We offer regular technical support, updates, bug resolution, level updates, events, and optimization on the platforms. Our professionally managed maintenance team allows for smooth operations, server monitoring quick response to technical issues or regulatory changes. ",
    },
  ];

  const clientexp = [
    {
      icon: Maskgroup,
      name: "Mathew",

      desc: "Raiden Labs turned our vision into a world-class casino platform that is truly above the industry standards. Their certified developers took the time to learn about our specific market needs and provided a tailored solution that was better than we expected. From consultation to platform launch, every step was done perfectly. Having an experienced casino development partner who knows the gaming industry inside and out has been invaluable. I would highly recommend Raiden Labs for any casino game development requirements!",
    },
    {
      icon: Maskgroup2,
      name: "James ",
      undername: " ",
      desc: "The professionalism and competence that Raiden Labs exhibited from day one was impressive. As a business looking for a solid casino gaming solution, we required developers who understood the intricacies of gaming rules as well as technical integration. With their more than 15 years of experience in the industry, they offered us strategic advice and helped us achieve a successful entry into the market. Our platform offers out-of-this-world gaming experiences, and our users have a great, secure play experience. Having selected Raiden Labs as our casino development partner was the best business choice.",
    },
    {
      icon: Maskgroup3,
      name: "Randy",
      undername: "  ",
      desc: "I am thoroughly impressed with Raiden Labs! Their casino game development services transformed our outdated platform into a modern, immersive gaming destination. Our games have become more engaging, and our players get a hassle-free experience. Selecting Raiden Labs as our casino game development company was one of the best decisions we ever made.",
    },
  ];
   const handleClick=(e)=>{
    
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div
          className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"
          style={{ minHeight: "100vh" }}
        >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">
              Casino Game Development Company
            </h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              Raiden Labs is a leading Casino Game Development company that
              provides secure and scalable Casino Gaming solutions. We develop
              engaging, high-performance casino games with leading-edge
              technologies to ensure maximum player engagement and revenue.
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
          <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className=" col-lg-6 text-center mt-2 mb-3">
            <img src={icon3} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Our Casino Game Development Solutions
            </h2>
            <p className="mt-4  h1-para" >
              Raiden Labs is at the forefront of the Casino Game Development
              sector, combining AI, blockchain, and cryptocurrency technology to
              deliver engaging gaming experiences on web, mobile, PC, and
              console platforms. Our tailored Casino Game Development services
              deliver secure, compliant, and lucrative gameplay environments.
              With a strong focus on advanced mechanics and responsible gaming,
              we are redefining industry standards. Join us to build your casino
              gaming portfolio
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Multi-currency support for international markets
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Provably fair gaming with blockchain confirmation
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Responsible gambling tools and features
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          The Facilities We Provide as a Casino Game Development Company
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          Raiden has been at the forefront of the game development industry,
          continuously producing immersive gaming environments that use unique
          technologies and provide entertaining activities.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Our End-to-End Casino Game Development Services
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            As a leading game development company, we create games that support
            all platforms, and we integrate games with blockchain technology
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                What We Offer
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Collaborate with us for bespoke casino software created for
                security, compliance, scalability, and unparalleled player
                experience in the aggressive online gaming space.
              </p>
              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                  Schedule a demo call
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            Raiden’s Advanced Tech and Flawless Casino
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge VR gameplay experience.
          </p>
          <CoreComponent32 />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal AR: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your AR app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37 />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Looking for Casino Game Developers?
              </h2>
              <p
                className="h1-para text-white  lh-base"
                style={{ opacity: 0.6 }}
              >
                We build market-leading casino games with Unity, Unreal Engine,
                Node.js, blockchain technology, and enterprise cloud
                infrastructure. With photorealistic graphics, certified RNG
                systems, and full regulatory compliance, we ensure top-notch
                gaming experiences and effective security measures.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
          Why Use Raiden Labs for Casino Game Development
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 ">
        <h2 className="text-center lh-base h2-heading ">
          The Development Process of Our Casino Games
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We’re dedicated to pushing the boundaries of technology—always looking
          for smarter, sharper solutions. At Raiden Labs, custom platforms
          aren’t just another project; we engineer them with security,
          scalability, and user engagement as core priorities. Interfaces aren’t
          just eye candy—they’re built for real-world use and real people.
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          How our Ludo game development has changed the business directly here
          from clients' experience and results, by partnering with us in their
          Ludo game development journey
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CasinoGameDev;
